'use es6';

export const isPreviewOnly = () => {
  return window.location.href.indexOf('isPreview=true') > 0;
};